import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/Core/services/auth.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  changePasswordForm!: FormGroup;


constructor(private fb: FormBuilder, private auth: AuthService) {}

ngOnInit() {
  this.changePasswordForm = this.fb.group({
  password: ['', Validators.required],
  new_password: ['', Validators.required],
  confirmPassword: ['', Validators.required]
  },
  {
    validator: this.ConfirmedValidator('new_password', 'confirmPassword'),
  });
}

onSubmit(form: FormGroup) {
  this.auth.changePassword(form.value)
}

ConfirmedValidator(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (
      matchingControl.errors &&
      !matchingControl.errors['confirmedValidator']
    ) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmedValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
}

